import React from "react";
import { useIntl } from "react-intl";

// UI
import MaterialTable from "@material-table/core";
import _ from "lodash";

import { tableIcons } from "../../TableIcons";
import AuthenticationService from "../../../services/AuthenticationService";
import apiRequest from "../../../services/apiRequest";
import TableStyle from "../../../components/TableStyle";

const OPTIONS = {
  filtering: true,
  pageSize: 10,
  searchFieldAlignment: "left",
  headerStyle: {whiteSpace: "nowrap"},
  showTitle: false,
  toolbar: false,
};

const getLocalization = (intl) => ({
  header: {
    actions: "",
  },
  body: {
    editRow: {
      deleteText: intl.formatMessage({ id: "delete_element" }),
    },
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} di {count}",
    labelRowsSelect: "",
  },
});

const RoleTable = ({ rows, setRow, push, columns, apiKey, roleKey }) => {
  const intl = useIntl();
  const scopes = AuthenticationService.getUserScopes();

  const _rows = rows && _.values(rows).map((user) => ({ ...user }));

  function manageUpdatedUser(oldData, newData) {
    const { [oldData.id]: tmp, ...rest } = rows;
    setRow({ ...rest, [newData.id]: newData });
  }

  const _onRowUpdate = (newData, oldData) =>
    new Promise((resolve, reject) => {
      let isEqual = true;
      Object.entries(newData).forEach(([key, value]) => {
        if (oldData[key] !== value) {
          isEqual = false;
        }
      });
      setImmediate(() => {
        if (isEqual) {
          resolve();
        } else {
          apiRequest
            .post(`/${apiKey}/${oldData.id}`, newData)
            .then(() => {
              manageUpdatedUser(oldData, newData);
              push({
                title: intl.formatMessage({ id: "updated" }),
                type: "success",
              });
              resolve();
            })
            .catch(() => {
              push({
                title: intl.formatMessage({ id: "server_error" }),
                type: "error",
              });
              reject();
            });
        }
      });
    });

  const _onRowDelete = (newData) =>
    new Promise((resolve, reject) => {
      setImmediate(() => {
        apiRequest
          .delete(`/${apiKey}/${encodeURIComponent(newData.id)}`)
          .then(() => {
            const { [newData.id]: tmp, ...rest } = rows;
            setRow({ ...rest });
            push({
              title: intl.formatMessage({ id: "deleted_role" }),
              type: "success",
            });
            resolve();
          })
          .catch(() => {
            push({
              title: intl.formatMessage({ id: "server_error" }),
              type: "error",
            });
            reject();
          });
      });
    });

  return (
    <TableStyle>
      <MaterialTable
        columns={columns}
        data={_rows}
        icons={tableIcons}
        isLoading={_rows === undefined || columns === undefined}
        options={OPTIONS}
        localization={getLocalization(intl)}
        editable={{
          ...(scopes.indexOf(`${roleKey}:update`) >= 0
            ? { onRowUpdate: _onRowUpdate }
            : {}),
          ...(scopes.indexOf(`${roleKey}:delete`) >= 0
            ? { onRowDelete: _onRowDelete }
            : {}),
        }}
      />
    </TableStyle>
  );
};

export default React.memo(RoleTable, (props, nextProps) => {
  // Render component only when rows changes
  return _.isEqual(props.rows, nextProps.rows);
});
